import { Stack } from 'expo-router'

export function Layout() {
  return (
    <Stack
      screenOptions={{
        headerShown: false,
      }}
    >
      <Stack.Screen name="partner-selection" />
      <Stack.Screen name="partner-detail" />
      <Stack.Screen name="points-transfer" />
      <Stack.Screen name="transfer-confirmation" />
      <Stack.Screen name="transfer-success" />
    </Stack>
  )
}
